var render = function render(){var _vm=this,_c=_vm._self._c;return _c('boxMoudle',{scopedSlots:_vm._u([{key:"topTitle",fn:function(){return [_c('div',{staticClass:"topTitleBox",style:({ left: _vm.left ? _vm.left : '0px' })},[_c('div',{staticClass:"topTitle-cont"},[_c('p',{staticClass:"m-textOverflow"},[_vm._v(_vm._s(_vm.title))])])])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }